module.exports = __webpack_public_path__ + "img/grouppeople.87a51fc8.svg";